module.exports = __webpack_public_path__ + "img/Yago.610361dc.png";